import { IconProps } from '../types';

function WireframeOutlineIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className || 'h-6 w-6'}
    >
      {/* Outer box */}
      <rect x="3" y="3" width="18" height="18" rx="1" />
      {/* Triangle subdivisions showing full wireframe mesh */}
      <path d="M3 3L21 21" strokeWidth="1" />
      <path d="M3 13H21" strokeWidth="1" />
      <path d="M13 3V21" strokeWidth="1" />
    </svg>
  );
}

export default WireframeOutlineIcon;
